import { z } from 'zod';
import { CategoryID } from '../ads/zod.js';

const voBannerColor = z.enum([
    'BLUE',
    'RED',
    'YELLOW',
    'PURPLE',
    'GREEN',
]);
const voBannerDesign = z.enum(['solid_dark', 'solid_lite']);
const voBannerIcon = z.union([
    z.enum(['DISCOUNT', 'TRUCK']),
    z.string(),
]);
z.enum(['web', 'iphone', 'ipad', 'android']);
const voBannerEntrypoints = z.enum([
    'NEWAD',
    'EDITAD',
    'PROMOTE',
    'RESERVEDAREA',
]);
const voBannerPages = z.enum([
    'PROMOTE',
    'MANAGEADS',
    'LEGACY_ADIN_STEP_1',
]);
const voBanner = z.object({
    bannerId: z.number(),
    title: z.string(),
    description: z.string(),
    code: z.string().optional(),
    placeholders: z.array(z.string()).optional(),
    icon: voBannerIcon.nullable().optional(),
    color: voBannerColor.nullable().optional(),
    design: voBannerDesign.nullable().optional(),
    tag: z.string().optional(),
    countdown: z.string().optional(),
    cta: z.object({
        label: z.string(),
        url: z.string(),
    }).optional()
});
const voBanners = z.object({
    banners: z.array(voBanner),
});
const privateBannerChannels = z.enum([
    'web',
    'iphone',
    'ipad',
    'android',
]);
const privateBannerRules = z.object({
    categories: z.array(z.nativeEnum(CategoryID)),
    channels: z.array(privateBannerChannels),
    entrypoints: z.array(voBannerEntrypoints),
    isPro: z.boolean(),
    pages: z.array(voBannerPages),
    placeholders: z.array(z.string()).optional(),
});
const privateBanner = voBanner.merge(privateBannerRules).merge(z.object({
    activeFrom: z.string(),
    activeTo: z.string(),
    enabled: z.boolean(),
    template: z.enum(['promote', 'adin']).optional()
}));
const bannerList = z.object({
    count: z.number(),
    banners: z.array(privateBanner),
});

export { bannerList, privateBanner, privateBannerChannels, privateBannerRules, voBanner, voBannerColor, voBannerDesign, voBannerEntrypoints, voBannerIcon, voBannerPages, voBanners };
//# sourceMappingURL=zod.js.map
